module.exports = __webpack_public_path__ + "static/step3-d29b49bce7e8235e83e770f51014e8e9.png";